var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.63636C4.93318 1.63636 1.63636 4.93318 1.63636 9C1.63636 13.0668 4.93318 16.3636 9 16.3636C13.0668 16.3636 16.3636 13.0668 16.3636 9C16.3636 4.93318 13.0668 1.63636 9 1.63636ZM0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z",
    fill: "#353A41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.27273C9.56484 6.27273 10.0227 5.81484 10.0227 5.25C10.0227 4.68516 9.56484 4.22727 9 4.22727C8.43516 4.22727 7.97727 4.68516 7.97727 5.25C7.97727 5.81484 8.43516 6.27273 9 6.27273Z",
    fill: "#353A41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 8.31818C7.5 7.86631 7.86631 7.5 8.31818 7.5H9C9.45187 7.5 9.81818 7.86631 9.81818 8.31818V12.284C10.2051 12.349 10.5 12.6855 10.5 13.0909C10.5 13.5428 10.1337 13.9091 9.68182 13.9091H9C8.54813 13.9091 8.18182 13.5428 8.18182 13.0909V9.12505C7.79486 9.06013 7.5 8.72359 7.5 8.31818Z",
    fill: "#353A41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b3ff064c33e6cfaec49219347990e61a.svg";
export { ForwardRef as ReactComponent };